//global stores
import { utilityMutations } from "../../../../../Core/Global/Store/utility";

export const state = {
    all: [],
    isSearchEnabled: true,
    isFiltersEnabled: true,
    isMapViewEnabled: false,
    isListViewEnabled: true,
    isGridViewEnabled: true,
    isServicesEnabled: true,
    isFindLocationEnabled: true,
    isPreferredLocationEnabled: true,
}

export const getters = {
    getAllSettings: state => {
        return state.all;
    }
}

export const mutations = {
    ...utilityMutations
}

export const actions = {
    setModuleSettings ({ commit }, value) {
        let mapEnabled               = parseInt(value.EM);
        let listEnabled              = parseInt(value.EL);
        let gridEnabled              = parseInt(value.EG);
        let servicesEnabled          = parseInt(value.ES);
        let filtersEnabled           = parseInt(value.EF);
        let findLocationEnabled      = parseInt(value.EFL);
        let preferredLocationEnabled = parseInt(value.EPL);
        let searchEnabled            = parseInt(value.ELS);

        commit('SET', ['all', value]);
        commit('SET', ['isMapViewEnabled', mapEnabled]);
        commit('SET', ['isSearchEnabled', searchEnabled]);
        commit('SET', ['isListViewEnabled', listEnabled]);
        commit('SET', ['isGridViewEnabled', gridEnabled]);
        commit('SET', ['isFiltersEnabled', filtersEnabled]);
        commit('SET', ['isServicesEnabled', servicesEnabled]);
        commit('SET', ['isFindLocationEnabled', findLocationEnabled]);
        commit('SET', ['isPreferredLocationEnabled', preferredLocationEnabled]);

        if(mapEnabled){
            commit('location/SET', ['activeView', 'map'], { root: true });
        } else if(listEnabled){
            commit('location/SET', ['activeView', 'list'], { root: true });
        } else if(gridEnabled){
            commit('location/SET', ['activeView', 'grid'], { root: true });
        }
    }
}

export default { namespaced: true, state, getters, mutations, actions };